import request from '@/http/http'
const PREFIX = 'api/deer/estates';
// 获取楼盘列表
export function getEstates(query) {
    return request({
        url:PREFIX,
        params: query 
    })
}
// 获取楼盘列表(登陆后无权限)
export function searchEstates(query) {
    return request({
        url:PREFIX+'/search',
        params: query 
    })
}
export function getPublicEstates(query) {
    return request({
        url:PREFIX+"/public",
        params: query 
    })
}
// 创建楼盘
export function createEstate(data) {
    return request({
        url: PREFIX,
        method: 'post',
        data
    })
}
// 删除楼盘
export function deleteEstate(id) {
    return request({
        url: PREFIX+ '/'+id,
        method: 'delete'
    })
}
// 批量删除楼盘
export function deleteEstates(data) {
    return request({
        url:PREFIX+  "?" + data,
        method: 'delete',
    })
}
// 更新网站上架状态
export function updatePushWeb(id,v) {
    return request({
        url: PREFIX+ '/'+id+'/update-pushWeb?isPushWeb='+v,
        method: 'put',
    })
}
// 更新分销商上架状态
export function updatePushChannel(id,v) {
    return request({
        url: PREFIX+ '/'+id+'/update-push-channel?isPushChannel='+v,
        method: 'put',
    })
}
// 更新主推状态
export function updateMainPush(id,data) {
    return request({
        url:PREFIX+  '/'+id+'/update-main-push',
        method: 'put',
        data
    })
}
// 获取基本信息
export function getBasicInfo(id) {
    return request({
        url:PREFIX+  '/'+id
    })
}
// 修改基本信息
export function updateBasicInfo(id,data) {
    return request({
        url:PREFIX+  '/'+id,
        method:'put',
        data
    })
}
// 获取项目人员信息
export function getCounselors(id) {
    return request({
        url:PREFIX+  '/'+id+'/counselors'
    })
}

export function getPublicCounselors(id) {
    return request({
        url:PREFIX+'/'+id+'/public-counselors'
    })
}
// 修改项目人员信息
export function updateCounselors(id,data) {
    return request({
        url:PREFIX+  '/'+id+'/update-counselors',
        method:'put',
        data
    })
}
// 获取卖点信息
export function getSalepoint(id) {
    return request({
        url:PREFIX+  '/'+id+'/salepoint'
    })
}
// 更新卖点信息
export function updateSalepoint(id,data) {
    return request({
        url:PREFIX+  '/'+id+'/update-salepoint',
        method:'put',
        data
    })
}
// 获取小区信息
export function getCommunity(id) {
    return request({
        url:PREFIX+  '/'+id+'/community'
    })
}
// 更新小区信息
export function updateCommunity(id,data) {
    return request({
        url:PREFIX+  '/'+id+'/update-community',
        method:'put',
        data
    })
}
// 获取户型列表
export function getHousetypes(id) {
    return request({
        url: PREFIX+ '/'+id+'/housetype-list'
    })
}
//  获取户型详情
export function getHousetypeInfo(id,typeId) {
    return request({
        url: PREFIX+ '/'+id+'/housetype/'+typeId
    })
}
// 删除户型
export function deleteHousetypes(id,typeId) {
    return request({
        url: PREFIX+ '/'+id+'/housetype/'+typeId,
        method: 'delete'
    })
}
// 添加户型
export function createHousetype(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/create-housetype',
        method: 'post',
        data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
// 更新户型信息
export function updateHousetype(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/update-housetype',
        method:'put',
        data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
// 创建预售证信息
export function createPresellcard(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/create-presellcard',
        method: 'post',
        data
    })
}
// 获取预售证列表
export function getPresellcards(id) {
    return request({
        url: PREFIX+ '/'+id+'/presellcard-list'
    })
}
// 删除预售证
export function deletePresellcard(id,cardId) {
    return request({
        url: PREFIX+ '/'+id+'/presellcard/'+cardId,
        method: 'delete'
    })
}
// 更新预售证
export function updatePresellcard(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/update-presellcard',
        method:'put',
        data
    })
}
// 获取素材
export function getMaterials(id) {
    return request({
        url: PREFIX+ '/'+id+'/accessory-materials',
    })
}
// 获取VR素材
export function getVrMaterials(id) {
    return request({
        url: PREFIX+ '/'+id+'/vr-materials'
    })
}
// 获取图片素材
export function getPhotoMaterials(id) {
    return request({
        url: PREFIX+ '/'+id+'/photo-materials'
    })
}

// 上传楼盘素材
export function uploadMaterials(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/upload-accessory-materials',
        method:'put',
        data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
// 上传楼盘图片
export function uploadPhotoMaterials(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/upload-photo-materials',
        method:'put',
        data,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}
// 批量删除楼盘素材
export function deleteMaterials(id,data) {
    return request({
        url:PREFIX+  "/" + id+'/delete-materials?' + data,
        method: 'delete',
    })
}
// 批量修改素材类别
export function updateMaterialsType(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/batch-update-material-type',
        method:'put',
        data
    })
}
// 下载素材
export function downloadMterial(id,params) {
    return request({
        url: PREFIX+ '/'+id+'/download-accessory-material',
        method:'put',
        params,
        responseType: 'blob'
    })
}
// 上传vr链接
export function uploadVr(id,data) {
    return request({
        url: PREFIX+ '/'+id+'/upload-vr-materials',
        method:'put',
        data,
    })
}
// 下载楼盘相册
export function downloadPhotoMterial(id,params) {
    return request({
        url: PREFIX+ '/'+id+'/download-photo-material',
        method:'put',
        params,
        responseType: 'blob'
    })
}
// 更新楼盘封面
export function updateCover(id,materialId) {
    return request({
        url: PREFIX+ '/'+id+'/update-cover/'+materialId,
        method:'put',
    })
}
// 更新VR封面
export function updateVrCover(id,materialId) {
    return request({
        url: PREFIX+ '/'+id+'/update-vr-cover/'+materialId,
        method:'put',
    })
}